import type { FaireProductEntity } from "../../entity_types/product";

export const p_q9e66qz8ud: FaireProductEntity = {
  token: "p_q9e66qz8ud",
  type: "product",
  name: "KIDS BATH BOMBS | 4 count",
  brandToken: "b_5dagse75md",
  brandName: "Rowe Casa Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/d469cdb92e3a0c19403c57bd1d80e31774752866c85b30d8062b6e89dc26d0b4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1c634e848718f8750e53042d8dcd7c2457463bb00251a235badd8145e3b190c5.png",
  ],
  priceDollars: 14,
  description:
    "\nMake bath time fun and exciting for kids without any toxic chemicals! Give your child the very best with these gentle and safe, all-natural bath bombs made with plant-based colorants, and 100% pure and natural therapeutic grade essential oils. They will love watching their colored bath bomb fizz and enjoy the fruity fun scent or be calmed down with our sweet dreams scent. 4 different colors are in each bag (Blue, Pink, Green & Yellow). \n\n",
  tags: [],
  msrpDollars: 20,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:05.639Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
